import { render } from "./LivingUnitAmenities.vue?vue&type=template&id=7a1aea8c"
import script from "./LivingUnitAmenities.vue?vue&type=script&lang=js"
export * from "./LivingUnitAmenities.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__